import Button from "@components/button/button";
import { ButtonSize, buttonTheme } from "@components/button/button-constants";
import Modal from "@components/modal/modal";
import { getTopicflowIcon } from "@components/topicflow-icon/topicflow-icon-helpers";

import ProfileSidebarDetails from "./profile-sidebar-details";

const ProfileDetailsModal = ({
  profileId,
  profileName,
  onClose,
}: {
  profileId: number;
  profileName?: string;
  onClose: () => void;
}) => {
  return (
    <Modal onClose={onClose}>
      <div className="flex items-center justify-between gap-4 px-6 py-4 border-b">
        <h2 className="tf-header-xl">
          {profileName ? `${profileName}'s details` : "Employee details"}
        </h2>
        <Button
          icon={getTopicflowIcon("close")}
          theme={buttonTheme.iconGray}
          size={ButtonSize.large}
          aria-label="Close employee details"
          onClick={onClose}
        />
      </div>
      <ProfileSidebarDetails profileId={profileId} />
    </Modal>
  );
};

export default ProfileDetailsModal;
